import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBf3mOJ_SnoTwnDMNUkt0kOFI157RRwr2o",
  authDomain: "magicmoonstudiosnew.firebaseapp.com",
  projectId: "magicmoonstudiosnew",
  storageBucket: "magicmoonstudiosnew.firebasestorage.app",
  messagingSenderId: "493706265432",
  appId: "1:493706265432:web:08ea86b846e14cbfbb5b2d",
  measurementId: "G-49FKWN1HBR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Allowed admin emails
export const ALLOWED_ADMIN_EMAILS = [
  'kallesh953@gmail.com',
  'magicmoonstudioss@gmail.com',
  'magicmoonstudiosserver@gmail.com'
];
